import Text from 'common/components/Text';
import NextImage from 'common/components/NextImage';
import Button from 'common/components/Button';
import Heading from 'common/components/Heading';
import Container from 'common/components/UI/Container';
import BannerWrapper, {
  BannerContent,
  BannerImage,
  BannerImageMobile,
  ButtonGroup,
  VideoWrapper,
} from './banner.style';



export interface PagesBannerProps {
  title?: string;
  subtitle?: string;
  bannerImg?: string;
  bannerImgMobile?: string;
}

const PagesBanner = ({
  title,
  subtitle,
  bannerImg,
  bannerImgMobile,
}: PagesBannerProps) => {

  return (
    <BannerWrapper id="home">
      <Container>
        <BannerContent>
          <Heading
            as="h1"
            content={title}
          />
          <Text content={subtitle} />
        </BannerContent>
        <BannerImage>
          <NextImage src={bannerImg} alt="Banner" />
        </BannerImage>
        <BannerImageMobile>
          <NextImage src={bannerImgMobile} alt="Mobile Banner" />
        </BannerImageMobile>
      </Container>
    </BannerWrapper>
  );
};

export default PagesBanner;
